import { createContext, type RefObject } from 'react';

/**
 * What every analyte row of the Labs results needs from the section above it (PROD-3275):
 * the root report id to performing lab map the sparkline joins points by, and the positioned
 * element the history popover portals into (the app's root `zoom` misplaces a body portal).
 */
export interface LabResultsContextValue {
  labsByRoot: ReadonlyMap<string, string>;
  popoverHost: RefObject<HTMLElement | null> | null;
}

export const LabResultsContext = createContext<LabResultsContextValue>({
  labsByRoot: new Map(),
  popoverHost: null,
});
